// src/utils/markdownUtils.js
export function markdownToHtml(text) {
    // 改进的URL匹配正则表达式
    const urlRegex = /(\b(https?:\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,}(?::\d+)?(?:\/[^\s<]*)?(?:\?[^\s<]*)?(?:#[^\s<]*)?\b)/gi;
    
    let html = text
      .replace(urlRegex, (match) => {
        // 检查是否已经是完整URL
        if (match.startsWith('http://') || match.startsWith('https://')) {
          return `<a href="${match}" target="_blank" class="content-link">${match}</a>`;
        } else {
          // 为纯域名添加https协议
          return `<a href="https://${match}" target="_blank" class="content-link">${match}</a>`;
        }
      })
      .replace(/\n/g, '<br>');
    
    return html;
  }









// 验证URL是否有效
export function isValidUrl(url) {
    // 更全面的URL验证正则表达式
    const pattern = /^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+([\w-.,@?^=%&:/~+#]*[\w-@?^=%&/~+#])?$/i;
    
    // 验证常见域名后缀（可选，不强制要求）
    const tldPattern = /\.(com|org|net|gov|edu|cn|io|co|uk|de|fr|jp|au|us)$/i;
    
    // 验证IP地址格式
    const ipPattern = /^https?:\/\/(\d{1,3}\.){3}\d{1,3}(:\d+)?(\/.*)?$/;
    
    // 验证本地地址
    const localhostPattern = /^https?:\/\/localhost(:\d+)?(\/.*)?$/i;
    
    // 主验证逻辑
    if (ipPattern.test(url) || localhostPattern.test(url)) {
        return true;
    }
    
    // 检查基本模式和域名后缀
    return pattern.test(url); // 移除了TLD强制要求
}